(function () {
  const bar = document.getElementById('sticky-atc-bar');
  if (!bar) return;

  const originalBtn = document.querySelector('[name="add"].js-atc-btn');
  if (!originalBtn) return;

  const stickyBtn = document.getElementById('sticky-atc-btn');
  if (!stickyBtn) return;

  const availableHTML = stickyBtn.dataset.available;
  const soldOutHTML = '<span>Tükendi</span>';
  const priceWrapper = bar.querySelector('.sticky-atc-bar__price');

  // Buton senkronizasyonu
  function syncButton() {
    const isDisabled = originalBtn.disabled;
    stickyBtn.disabled = isDisabled;
    stickyBtn.innerHTML = isDisabled ? soldOutHTML : availableHTML;
  }

  new MutationObserver(syncButton).observe(originalBtn, {
    attributes: true,
    attributeFilter: ['disabled']
  });

  // Sticky butona tıkla
  stickyBtn.addEventListener('click', function () {
    originalBtn.click();
  });

  // Bar görünürlüğü
  new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      bar.classList.toggle('is-visible', !entry.isIntersecting);
      bar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
    });
  }, { threshold: 0.2 }).observe(originalBtn);

  // Fiyat güncelleme
  const originalPrice = document.querySelector('.js-price');
  const originalCompare = document.querySelector('.js-price-compare');

  function updatePrice() {
    if (!priceWrapper) return;
    const price = originalPrice ? originalPrice.textContent.trim() : '';
    const compare = originalCompare ? originalCompare.textContent.trim() : '';
    const compareVisible = originalCompare && !originalCompare.classList.contains('d-none');

    if (compareVisible && compare) {
      priceWrapper.innerHTML =
        '<span class="sticky-atc-bar__price--sale">' + price + '</span>' +
        '<s class="sticky-atc-bar__price--compare">' + compare + '</s>';
    } else {
      priceWrapper.innerHTML = '<span>' + price + '</span>';
    }
  }

  if (originalPrice) {
    new MutationObserver(updatePrice).observe(originalPrice, { childList: true, subtree: true, characterData: true });
  }
  if (originalCompare) {
    new MutationObserver(updatePrice).observe(originalCompare, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
  }

  // Animasyon — sepete ekle sonrası
  stickyBtn.addEventListener('click', function () {
    stickyBtn.classList.remove('hvr-bob');
    void stickyBtn.offsetWidth;
    stickyBtn.classList.add('hvr-bob');
    setTimeout(function () {
      stickyBtn.classList.remove('hvr-bob');
    }, 3000);
  });

  setTimeout(updatePrice, 300);

})();
